import React, { Component } from 'react'
var ReCAPTCHA = require('react-google-recaptcha').default
let captcha


class ReCaptchaField extends Component {

	componentDidMount() {
		captcha.execute()
	}

	render() {
		const reCaptchaSiteKey =process.env.REACT_APP_PLICKERS_RECAPTCHA_SITE_KEY
		return (
			<div>
				<ReCAPTCHA
					ref={(el) => { captcha = el }}
					size="invisible"
					sitekey={reCaptchaSiteKey}
					onChange={this.props.input.onChange}
				/>
			</div>
		)
	}
}



export default ReCaptchaField 



// WEBPACK FOOTER //
// ./src/components/forms/ReCaptchaField.js